import { withRouter } from 'react-router-dom'
import {
  combine,
  withContext,
  withCallback,
  withState,
} from 'react-hooks-combine'
import { StoreContext } from 'store/context'

import BalanceAccess from './component'

export default combine({
  hocs: [withRouter],

  hooks: [
    withContext('appStore', StoreContext),

    withState('isLoadingTotalInWins', 'setIsTotalInWinsLoading', true),
    withCallback(
      'loadTotalInWins',
      ({ setIsTotalInWinsLoading, appStore }) =>
        async () => {
          setIsTotalInWinsLoading(true)
          await appStore.inwins.load()
          setIsTotalInWinsLoading(false)
        },
      []
    ),
    withCallback(
      'loadTotalBalance',
      ({ appStore }) =>
        async () => {
          const entity = appStore.auth.loggedEntity
          return await entity.wallet.requestBalance()
        },
      []
    ),
  ],
})(BalanceAccess)
